import React from "react";
import moment from "moment";

import { CampoEstatico, Card, TipoCampoEstatico } from "@intechprev/componentes-web";

interface IProps {
  ultimaFolha: any | null
}

export const UltimaFolha: React.FC<IProps> = ({
  ultimaFolha
}) => {

  function valorFolha() {
    const proventos = ultimaFolha.provento;
    const descontos = ultimaFolha.desconto;
    let valor = 0;

    for (let p = 0; p < proventos.length; p++) {
      valor = valor + proventos[p].VALOR_MC;
    }

    for (let d = 0; d < descontos.length; d++) {
      valor = valor - descontos[d].VALOR_MC;
    }

    return valor;
  }

  if (ultimaFolha !== null && ultimaFolha !== undefined && ultimaFolha.provento.length > 0) {
    return (
      <Card titulo={"Total do Benefício em"} textoBadge={moment(ultimaFolha.provento[0].DT_COMPETENCIA, "DD/MM/YYYY").format("MM/YYYY")} tipoBadge={Card.TipoBadge.success}>
        {/* <h6 className={"text-right text-secondary mb-4"}></h6> */}
        <br />
        <h2 className={"text-center mb-5"}>Valor Líquido: <CampoEstatico valor={valorFolha()} tipo={TipoCampoEstatico.dinheiro} /></h2>
      </Card>
    )
  }

  return (
    null
  );
}